import styled from 'styled-components';
import { IconSizesType } from '../ThemeProvider/types';

export const SpinnerContainer = styled.div<{
  size: IconSizesType;
}>`
  width: ${({ theme, size }) => theme.basicIcon[size].size}px;
  height: ${({ theme, size }) => theme.basicIcon[size].size}px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: auto !important;
`;

export const Icon = styled.div<{ disabled: boolean }>`
  & > div {
    cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
  }
`;
